var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43239 20.7071C9.43237 20.4447 9.53662 20.1929 9.7222 20.0073C9.90778 19.8217 10.1595 19.7174 10.422 19.7174L16.36 19.7169C16.6224 19.7169 16.8742 19.8211 17.0598 20.0067C17.2454 20.1923 17.3497 20.444 17.3497 20.7065C17.3497 20.969 17.2455 21.2207 17.0599 21.4063C16.8743 21.5919 16.6226 21.6962 16.3601 21.6962L10.4221 21.6967C10.1597 21.6967 9.90793 21.5925 9.72232 21.4069C9.5367 21.2213 9.43242 20.9696 9.43239 20.7071Z",
    fill: "url(#paint0_linear_56093_78690)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2787 4.87131C24.2787 4.60884 24.1744 4.35712 23.9888 4.17154C23.8031 3.98596 23.5514 3.88171 23.2889 3.88173C23.0265 3.88175 22.7747 3.98604 22.5892 4.17166C22.4036 4.35727 22.2993 4.609 22.2994 4.87148L22.2995 6.8508L10.4236 6.85178L10.4234 4.87377C10.4234 4.6113 10.3191 4.35958 10.1335 4.174C9.94787 3.98842 9.69613 3.88417 9.43366 3.88419C9.17118 3.88421 8.91947 3.9885 8.73389 4.17412C8.5483 4.35973 8.44406 4.61146 8.44408 4.87394L8.44424 6.8493L7.45194 6.84939C6.40204 6.84947 5.39517 7.26663 4.65284 8.00908C3.91051 8.75153 3.49353 9.75846 3.49361 10.8084L3.49483 25.6559C3.49492 26.7058 3.91207 27.7127 4.65453 28.455C5.39698 29.1974 6.40391 29.6144 7.45381 29.6143L25.2677 29.6128C26.3176 29.6127 27.3245 29.1956 28.0668 28.4531C28.8092 27.7107 29.2262 26.7037 29.2261 25.6538L29.2248 10.8076C29.2248 9.75767 28.8076 8.7508 28.0652 8.00847C27.3227 7.26614 26.3158 6.84915 25.2659 6.84924L24.2788 6.84932L24.2787 4.87131ZM5.47416 25.6558L5.47335 15.7592C5.4733 15.2342 5.6818 14.7307 6.05296 14.3595C6.42413 13.9883 6.92756 13.7797 7.45251 13.7797L25.2664 13.7782C25.7914 13.7782 26.2949 13.9867 26.6661 14.3578C27.0373 14.729 27.2459 15.2324 27.2459 15.7574L27.2467 25.654C27.2468 26.1789 27.0383 26.6824 26.6671 27.0536C26.296 27.4249 25.7925 27.6334 25.2676 27.6335L7.45365 27.6349C6.9287 27.635 6.42523 27.4265 6.05401 27.0553C5.68278 26.6842 5.4742 26.1807 5.47416 25.6558Z",
    fill: "url(#paint1_linear_56093_78690)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5133 17.7462L9.76468 17.7473",
    stroke: "url(#paint2_linear_56093_78690)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56093_78690",
    x1: 13.391,
    y1: 19.7171,
    x2: 13.3911,
    y2: 21.6965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56093_78690",
    x1: 16.3587,
    y1: 3.8823,
    x2: 16.3608,
    y2: 29.6135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_56093_78690",
    x1: 16.639,
    y1: 17.7468,
    x2: 16.6389,
    y2: 16.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.62
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.246ac09a56f6c43e3d1a305540383e81.svg";
export { ForwardRef as ReactComponent };